import { useStripeProducts } from "../../../utils/context/stripe.context";

const useFetchProducts = () => {
  return useStripeProducts();
};

export default useFetchProducts;
